import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["id", "name", "value", "checked", "disabled", "aria-hidden"];
const _hoisted_2 = ["for"];
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "rec-radio-button__label" };
const _hoisted_5 = {
    key: 0,
    class: "rec-radio-button__sub-label"
};
import { vTooltip } from "@/common/directives/tip-directive";
import { useVModel } from "@vueuse/core";
import { computed } from "vue";
// Components
import SvgIcon from "@/common/components/SvgIcon.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecRadioButtons',
    props: {
        modelValue: {},
        items: {},
        id: { default: () => crypto.randomUUID() },
        name: { default: "" },
        buttonClass: { default: "" },
        disabled: { type: Boolean, default: false },
        clickBubbleUp: { type: Boolean, default: false },
        hideInput: { type: Boolean, default: false }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const model = useVModel(props, "modelValue", emit); // TODO: use defineModel instead
        const computedItems = computed(() => props.items.map((item) => ({ ...item, disabled: props.disabled ?? item.disabled })));
        const onClick = (e) => {
            if (props.clickBubbleUp)
                return;
            e.stopPropagation();
        };
        const getKey = (index) => `radio-button-${props.id}-${index}`;
        return (_ctx, _cache) => {
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedItems.value, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: getKey(i),
                    class: _normalizeClass([
                        'rec-radio-button',
                        __props.buttonClass,
                        {
                            'rec-radio-button--hidden-input': __props.hideInput,
                            'rec-radio-button--hidden': item.hidden
                        }
                    ]),
                    onClick: _withModifiers(onClick, ["stop"])
                }, [
                    _withDirectives(_createElementVNode("input", {
                        id: getKey(i),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                        name: __props.name || __props.id,
                        value: item.value,
                        checked: _unref(model) === item.value,
                        disabled: item.disabled,
                        "aria-hidden": item.hidden,
                        type: "radio",
                        onUpdate: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"])),
                        onChange: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"]))
                    }, null, 40, _hoisted_1), [
                        [_vModelRadio, _unref(model)]
                    ]),
                    _createElementVNode("label", {
                        for: getKey(i),
                        onClick: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        _renderSlot(_ctx.$slots, "prepend-icon", {}, () => [
                            (typeof item.prependIcon === 'string')
                                ? (_openBlock(), _createBlock(SvgIcon, {
                                    key: 0,
                                    icon: item.prependIcon,
                                    class: "rec-radio-button__icon"
                                }, null, 8, ["icon"]))
                                : (!!item.prependIcon)
                                    ? _withDirectives((_openBlock(), _createBlock(SvgIcon, {
                                        key: 1,
                                        src: item.prependIcon.src,
                                        icon: item.prependIcon.icon,
                                        class: "rec-radio-button__icon"
                                    }, null, 8, ["src", "icon"])), [
                                        [_unref(vTooltip), item.prependIcon.tooltip]
                                    ])
                                    : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", {
                            class: "rec-radio-button__label-wrap",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            (_ctx.$slots.label || item.label)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createElementVNode("span", _hoisted_4, [
                                        _renderSlot(_ctx.$slots, "label", _mergeProps({ ref_for: true }, { index: i, ...item }), () => [
                                            _createTextVNode(_toDisplayString(item.label), 1)
                                        ])
                                    ]),
                                    (_ctx.$slots['sub-label'] || item.subLabel)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                            _renderSlot(_ctx.$slots, "sub-label", _mergeProps({ ref_for: true }, { index: i, ...item }), () => [
                                                _createTextVNode(_toDisplayString(item.subLabel), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            (item.tag)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(['rec-radio-button__tag label', `label-hollow-${item.tagClass ?? 'empty'}`])
                                }, _toDisplayString(item.tag), 3))
                                : _createCommentVNode("", true)
                        ]),
                        _renderSlot(_ctx.$slots, "append-icon", {}, () => [
                            (typeof item.appendIcon === 'string')
                                ? (_openBlock(), _createBlock(SvgIcon, {
                                    key: 0,
                                    icon: item.appendIcon,
                                    class: "rec-radio-button__icon"
                                }, null, 8, ["icon"]))
                                : (!!item.appendIcon)
                                    ? _withDirectives((_openBlock(), _createBlock(SvgIcon, {
                                        key: 1,
                                        src: item.appendIcon.src,
                                        icon: item.appendIcon.icon,
                                        class: "rec-radio-button__icon"
                                    }, null, 8, ["src", "icon"])), [
                                        [_unref(vTooltip), item.appendIcon.tooltip]
                                    ])
                                    : _createCommentVNode("", true)
                        ])
                    ], 8, _hoisted_2)
                ], 2));
            }), 128));
        };
    }
});
